import React, { useEffect, useState, useRef } from "react";
import "firebase/firestore";

import { firebaseFirestore } from "./firebase";
import firebase from "firebase";
import { Letter, InboxItem } from "./models";

function LettersTable() {
  const [letters, setLetters] = useState<Letter[]>([]);
  const [loading, setLoading] = useState(true);

  const lettersListener = useRef<Function>();

  useEffect(() => {
    lettersListener.current = firebaseFirestore
      .collection("letters")
      .where("published", "==", false)
      .orderBy("creationDate", "desc")
      .limit(50)
      .onSnapshot(
        (snapshot) => _handleSnapshot(snapshot),
        (error) => console.error("Error fetching letters:", error)
      );

    return () => {
      if (lettersListener.current) {
        lettersListener.current();
      }
    };
  }, []);

  const _handleSnapshot = (
    snapshot: firebase.firestore.QuerySnapshot
  ): void => {
    const docs = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        published: data.published ?? false,
        creationDate: data.creationDate,
        requestMessage: data.requestMessage ?? "No request message provided",
        letterMessage: data.letterMessage ?? "No letter message provided",
        letterSenderID: data.letterSenderID ?? "",
        letterSenderAvatar: data.letterSenderAvatar ?? "",
        recipientID: data.recipientID ?? "",
        publishFailures: data.publishFailures ?? [],
      } as Letter;
    });
    setLetters(docs);
    setLoading(false);
  };

  const forcePublish = async (letter: Letter) => {
    if (letter.published) return;

    if (
      !window.confirm("Are you sure you want to publish this?") ||
      !window.confirm("Are you REAAALLY sure you want to publish this?")
    ) {
      return;
    }

    try {
      const batch = firebaseFirestore.batch();
      const letterDoc = firebaseFirestore.collection("letters").doc(letter.id);

      batch.update(letterDoc, {
        published: true,
      });

      const inboxItemDoc = firebaseFirestore
        .collection("users")
        .doc(letter.recipientID)
        .collection("inbox")
        .doc();
      const inboxItemData: InboxItem = {
        id: inboxItemDoc.id,
        creationDate: firebase.firestore.Timestamp.now(),
        linkedContentID: letter.id,
        linkedContentCreatorID: letter.letterSenderID,
        linkedContentAvatar: letter.letterSenderAvatar,
        linkedContentExcerpt: letter.letterMessage.slice(0, 50),
      };
      batch.set(inboxItemDoc, inboxItemData);

      await batch.commit();
      console.log(`Letter ${letter.id} published successfully.`);
    } catch (error) {
      console.error("Error publishing letter:", error);
    }
  };

  return (
    <>
      <h1 className="title">Unpublished Letters</h1>
      <p className="subtitle is-6">Ordered by most recent. Limit 50.</p>
      {loading ? (
        <div>Loading...</div>
      ) : letters.length ? (
        <table className="table is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>#</th>
              <th>Meta</th>
              <th>Message</th>
              <th>Failures</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {letters.map((letter, index) => (
              <tr key={letter.id}>
                <td>{index + 1}</td>
                <td>
                  <strong>
                    {letter.creationDate?.toDate().toLocaleDateString()}
                  </strong>
                  <br />
                  <span className="has-text-grey">
                    {letter.creationDate?.toDate().toLocaleTimeString()}
                  </span>
                </td>
                <td>
                  {letter.requestMessage}
                  <br />
                  <strong>{letter.letterMessage}</strong>
                </td>
                <td>
                  {letter.publishFailures?.length ? (
                    <ol className="content is-small">
                      {letter.publishFailures.map((failure, idx) => (
                        <li key={idx}>{failure}</li>
                      ))}
                    </ol>
                  ) : (
                    "n/a"
                  )}
                </td>
                <td>
                  <span className={`tag ${letter.published ? "is-warning" : ""}`}>
                    {letter.published ? "Published" : "Unpublished"}
                  </span>
                </td>
                <td>
                  {!letter.published ? (
                    <button
                      className="button is-small is-danger"
                      onClick={() => forcePublish(letter)}
                    >
                      Publish
                    </button>
                  ) : (
                    "n/a"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div>No unpublished letters found.</div>
      )}
    </>
  );
}

export default LettersTable;
